import React, { useEffect, useState } from "react";
import { ExportButton } from "../../components/micro/input";
import { Close, PDFFileIcon, SortDownArrow } from "../../assets/svg";
import CustomTable from "../../components/customTable/CustomTable";
import { getCompanyViewServiceList } from "../../redux/reports/slice";
import { useDispatch, useSelector } from "react-redux";
import ViewServiceReport from "../serviceRequest/servicereport/ViewServiceReport";
import { createDocument } from "../../redux/companies/slice";
import { toast } from "react-toastify";

export default function ViewService({
  initialServiceData,
  setViewServicePopup,
}) {
  const dispatch = useDispatch();
  const [servicePageCount, setServicePageCount] = useState(1);
  const [servicePageLimit, setServicePageLimit] = useState(10);
  const [sortBy, setSortBy] = useState("");
  const [sortDirection, setSortDirection] = useState("desc");
  const [selectedSaleId, setSelectedSaleId] = useState(null);
  const [isModal, setIsModal] = useState(false);
  const [documentData, setDocumentData] = useState([]);

  const companyId = initialServiceData?.company_id;

  // Selector
  const { getCompanyViewServiceListData, loading } = useSelector((store) => ({
    getCompanyViewServiceListData:
      store?.salesReportData?.getCompanyViewServiceListStatus?.data,
    loading: store?.salesReportData?.loading,
  }));

  useEffect(() => {
    if (companyId) {
      dispatch(
        getCompanyViewServiceList({
          sort_by: sortBy,
          sort_direction: sortDirection === "asc" ? "asc" : "desc",
          companyId,
          service_page: servicePageCount || "",
          service_limit: servicePageLimit || "",
        })
      );
    }
  }, [servicePageCount, servicePageLimit, companyId, sortBy, sortDirection]);

  const ColumnHeaders = () => (
    <>
      <th className="p-2 text-sm font-normal py-4 px-4 text-mgrey text-start">
        No.
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("service_id");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Service ID</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "service_id"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("outlet_name");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span>Outlet</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "outlet_name" ? "rotate-180" : ""
            }`}
          />
        </div>
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-sm font-normal py-4 px-4 text-mgrey text-start"
      >
        <div
          className="flex items-center"
          onClick={() => {
            setSortBy("request_types");
            setSortDirection(sortDirection === "desc" ? "asc" : "desc");
          }}
        >
          <span> Request Types</span>
          <SortDownArrow
            className={`ml-1 transition-transform duration-300 ${
              sortDirection === "asc" && sortBy === "request_types"
                ? "rotate-180"
                : ""
            }`}
          />
        </div>
      </th>
      <th className="p-2 text-sm font-normal py-4 px-4 text-mgrey text-start">
        Service Report
      </th>
    </>
  );

  const DataRows = () =>
    getCompanyViewServiceListData?.data?.services?.data?.map((item, index) => (
      <tr
        key={item.id}
        className="text-[14px] shadow-sm text-mgrey hover:bg-lightprimaryorange"
      >
        <td className="p-4 text-sm text-primaryBlack">
          {String(
            index + 1 + (servicePageCount - 1) * servicePageLimit
          ).padStart(2, "0")}
        </td>
        <td className="p-4 text-sm text-primaryBlack">
          {item.service_id || "-"}
        </td>
        <td className="p-4 text-sm text-primaryBlack">
          {item.outlet_name || "-"}
        </td>
        <td className="p-4 text-sm text-primaryBlack">
          {item.request_types || "-"}
        </td>
        <td className="px-4 py-2 text-center">
          <PDFFileIcon
            className={`cursor-pointer ${
              !item?.service_report_id ? "opacity-50 pointer-events-none" : ""
            }`}
            onClick={() => {
              if (!item?.service_report_id) return;
              setSelectedSaleId([item.service_report_id]);
              setIsModal(true);
            }}
          />
        </td>
      </tr>
    ));

  const handleExportCSV = () => {
    const serviceData = getCompanyViewServiceListData?.data?.services?.data;

    if (!serviceData?.length) return;

    const headers = ["Sr. No", "Service ID", "Outlet Name", "Request Type"];

    const csvRows = [
      headers.join(","),
      ...serviceData.map((item, index) => {
        return [
          String(
            index + 1 + (servicePageCount - 1) * servicePageLimit
          ).padStart(2, "0"),
          item.service_id || "-",
          item.outlet_name || "-",
          item.request_types || "-",
        ].join(",");
      }),
    ];

    const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
    const encodedUri = encodeURI(csvContent);

    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "view_services.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const documentIds = getCompanyViewServiceListData?.data?.services?.data
      ?.map((report) => report?.sale_service_document)
      ?.filter((id) => id != null);

    if (documentIds?.length) {
      setDocumentData(documentIds);
    }
  }, [getCompanyViewServiceListData]);

  const handleDownloadPDF = async () => {
    try {
      const response = await dispatch(
        createDocument({ ids: documentData })
      ).unwrap();

      const zipUrl = response?.zip;
      if (zipUrl) {
        const a = document.createElement("a");
        a.href = zipUrl;
        a.download = "report_documents.zip";
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        toast.error("ZIP URL not found in response.");
      }
    } catch (error) {
      toast.error("Failed to generate document ZIP.");
    }
  };

  return (
    <>
      <div className="model" onClick={() => setViewServicePopup(false)}>
        <div
          className="bg-white rounded-lg w-full max-w-4xl p-6 relative h-3/4 overflow-auto"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex justify-between mb-4">
            <h2 className="text-xl font-medium">
              {initialServiceData?.company_name}
            </h2>
            <div className="flex gap-3 items-center">
              <ExportButton value="EXPORT CSV" onClick={handleExportCSV} />
              <ExportButton
                value="ALL SERVICE REPORT"
                onClick={handleDownloadPDF}
              />
              <button
                onClick={() => setViewServicePopup(false)}
                className="text-xs flex gap-1"
              >
                <Close />
              </button>
            </div>
          </div>

          {/* Table */}
          <div className="overflow-x-auto rounded-lg">
            <CustomTable
              columnHeaders={<ColumnHeaders />}
              dataRows={<DataRows />}
              data={getCompanyViewServiceListData?.data?.services}
              loading={loading}
              showPagination={true}
              current={servicePageCount}
              total={getCompanyViewServiceListData?.data?.services?.total}
              lastPage={Math.ceil(
                getCompanyViewServiceListData?.data?.services?.total /
                  servicePageLimit
              )}
              paginationData={(newPage) => setServicePageCount(newPage)}
              paginationCurrentLimit={servicePageLimit}
              setPaginationCurrentLimit={(newLimit) => {
                setServicePageLimit(newLimit);
                setServicePageCount(1);
              }}
            />
          </div>
        </div>
      </div>
      {isModal && (
        <div>
          <ViewServiceReport
            onClose={() => {
              setIsModal(false);
            }}
            selectedSaleId={selectedSaleId}
          />
        </div>
      )}
    </>
  );
}
